import { render, staticRenderFns } from "./SidebarCategories.vue?vue&type=template&id=5bfccf5a&"
import script from "./SidebarCategories.vue?vue&type=script&lang=js&"
export * from "./SidebarCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports